import React from "react";
import {Col, Row} from "antd";
import CardItem from "./CardItem";
import './card.css';

const CardContainer = ({card}) => {

    return (

        <Row gutter={{xs: 86, sm: 86, md: 46, lg: 36}} className="px-8 pr-0 w-full sm-px-0">
            {card.map((item, index) => {
                return (
                    <Col md={8} lg={8} className="gutter-row mb-8" key={index}>
                        <CardItem item={item} />
                    </Col>
                )
            })}
        </Row>
    )
}

export default CardContainer;